import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Typography, { ITypographyProps } from "../Typography/Typography";

export const ClearFileLink = styled(Typography)`
  color: ${(props) => props.theme.errorColor};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`;

const ClearErrorButton = (props: ITypographyProps) => {
  const { t } = useTranslation();
  return (
    <ClearFileLink size="md" weight="bold" {...props}>
      {t("remove")}
    </ClearFileLink>
  );
};

export default ClearErrorButton;
